/**
 * switches
 */

import Component from "../../js/lib/component";
import $ from "jquery";

const classList = {
  root: ".js-switches",
  button: ".js-switches-button",
  select: ".js-switches-select"
};

export default class Switches extends Component {
  init() {
    const $active = this.$.button.filter(".is-active").first();
    const $first = this.$.button.first();
    const $current = $active.length ? $active : $first;

    this.set({
      type: $current.data("type") || ""
    });

    if (this.$.select.length) {
      this.Select = this.childs("Select")._one();
    }
  }
  events() {
    this.$.select.on("select:change", e => {
      e.stopPropagation();
      // this.handler(this.Select.getValue());
    });

    this.$.select.on("select:change", e => {
      e.stopPropagation();
      this.handler(this.Select.getValue());
    });

    this.$.button.on("mousedown", () => {
      this.move = 0;
      this.$.button.on("mousemove", () => {
        this.move++;
      });
      this.$.button.one("mouseup", () => {
        this.$.button.off("mousemove");
      });
    });

    this.$.button.on("click", e => {
      if (this.move > 10) return;

      e.preventDefault();

      const $target = $(e.currentTarget);
      const type = $target.data("type");

      this.handler(type);
    });
  }
  handler(type) {
    this.set({ type });
    this.$.root.trigger("switches:change", { type });
  }
  toggle() {
    const type = this.get("type");

    this.$.button
      .removeClass("is-active")
      .filter(`[data-type='${type}']`)
      .addClass("is-active");

    if (this.Select) {
      this.Select.setValue(type);
    }
  }
}

Component.mount(Switches, {
  name: "Switches",
  state: {
    type: ""
  },
  classList
});
